import React, { useState, ReactNode } from "react";
import "./Tooltip.css";

// Define the allowed placement values
type TooltipPlacement = "top" | "right" | "bottom" | "left";

interface TooltipProps {
  children: JSX.Element;
  title: string | ReactNode;
  placement?: TooltipPlacement;
  disabled?: boolean;
  tooltipStyle?: React.CSSProperties;
}

export const Tooltip = ({ children, title, placement = "top", disabled, tooltipStyle }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="tooltip-container" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
      {children}
      {!disabled && isVisible && (
        <div className={`tooltip-content ${placement}`} style={tooltipStyle}>
          {title}
        </div>
      )}
    </div>
  );
};
